import React, { useState, useEffect, useRef, useContext } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import "./ProgramsDash.css";
import Menu from "../../components/menu/Menu";
import Programs from "../../components/programs/Programs";
import { Context } from "../../context/Context";

const ProgramsDash = (props) => {

  const {programsData, setProgramsData, protocolsData, setProtocolsData, contentProgramsLoaded, setContentProgramsLoaded } = useContext(Context);
  
  useEffect(() => {
    localStorage.removeItem("taskBuilder");
    localStorage.removeItem("fromExerBuilder");
    localStorage.removeItem("disableUnLoad");
    localStorage.removeItem("ExerBuilderEdited");
    localStorage.removeItem("taskBuilderType");
    localStorage.removeItem("showPatientEditingAlert");
    localStorage.removeItem("programDurationEdit");
    localStorage.removeItem("prev_link");
  }, [])
  
  // const [contentProgramsLoaded, setContentProgramsLoaded] = useState(false);
  let { tab2 } = useParams();
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState(tab2 ? "Protocols" : "Recovery Plan");

  const handleSelectedTab = (tab) => {
    if(programsData?.length <= 0 || protocolsData?.length <= 0)
    {
      setContentProgramsLoaded(false);
    }
    setSelectedTab(tab);
    setSearch("");
    if (tab === "Recovery Plan" && tab2) {
      navigate("/programs");
    } else if(tab === "Protocols" && !tab2){
      navigate("/programs/tab2")
    }
  };
  // const [programsData, setProgramsData] = useState([]);

  const [search, setSearch] = useState("");
  const searchProgs = useRef("");
  const [isSorted, setSorted] = useState(true);
  const [tempToDelete, setTempToDelete] = useState(-1);
  const [restartTemps, setRestartTemps] = useState(false);
  const [successPopUp, setSuccessPopUp] = useState("");

  
  const popupRef = useRef(successPopUp);
  useEffect(() => {
    popupRef.current = successPopUp;
    const timeout = setTimeout(() => {
      setSuccessPopUp("");
    }, 5000);
    return () => {
      clearTimeout(timeout);
    };
  }, [successPopUp]);


  useEffect(() => {
    // localStorage.removeItem("programIdEdit");
    // localStorage.removeItem("programDataEdit");
    props.actSidebar(true);
    var userData = JSON.parse(localStorage.getItem("userData"));
    if (userData === null) {
      props.checkLoggedIn(false);
    } else {
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_programs/all-programs", {
          search,
          selectedTab: selectedTab === "Protocols" ? "Templates" : "Programs",
        })
        .then((res) => {
          if (res.data.responseData) {
            if (selectedTab === "Protocols") {
              for (var resData of res.data.responseData) {
                resData.modalOpened = false;
              }
            }
            selectedTab === "Protocols" ? setProtocolsData([]) : setProgramsData([])
            localStorage.removeItem("new_program");
            localStorage.removeItem("new_tasks");
            // localStorage.removeItem("programDataEdit");
            localStorage.removeItem("prev_link");
            localStorage.removeItem("fromExerBuilder");

            localStorage.removeItem("imported_tasks");
            localStorage.removeItem("inserted_activities");
            localStorage.removeItem("deleted_activities");

            localStorage.removeItem("inserted_tasks");
            localStorage.removeItem("deleted_tasks");
            localStorage.removeItem("start_date");
            localStorage.removeItem("as_template");
            localStorage.removeItem("is_assigned");
            localStorage.removeItem("dayInx");
            localStorage.removeItem("taskInx");
            localStorage.removeItem("hasEditImportBeenUsed");
            localStorage.removeItem("programDataBeforeImport");
            localStorage.removeItem("hasEditPermission");
            selectedTab === "Protocols" ? setProtocolsData(res.data.responseData ? res.data.responseData?.sort((a, b) => a?.id - b?.id) : []) : setProgramsData(res.data.responseData ? res.data.responseData?.sort((a, b) => a?.id - b?.id) : [])
            setContentProgramsLoaded(true);
          }
        })
        .catch((error) => {
          console.error(error);
          if (error.response.data.responseCode === 400 || error.response.data.responseCode === 401) {
            props.checkLoggedIn(false);
          }
        });
    }
  }, [props, search, selectedTab, restartTemps]);

  const openModal = (item, event) => {
    event.stopPropagation();
    var programData = [...programsData];
    programData[item].modalOpened = !programData[item].modalOpened;
    setProgramsData(programData);
  };

  const closeAllModal = () => {
    var data = [...programsData];
    for (let m of data) {
      m.modalOpened = false;
    }
    setProgramsData(data);
  };

  const updateSearchQuery = (value) => {
    // setContentProgramsLoaded(false);
    if (value && value.length >= 3) {
      setSearch(value);
    } else if (value === "" || value === null) {
      setSearch("");
    }
  };

  const handleSorting = (column, array) => {
    if (!isSorted) {
      var sorted = [...array].sort(function (a, b) {
        if (a[column] < b[column]) {
          return -1;
        }
        if (a[column] > b[column]) {
          return 1;
        }
        return 0;
      });
      setSorted(true);
    } else {
      sorted = [...array].sort(function (a, b) {
        if (a[column] > b[column]) {
          return -1;
        }
        if (a[column] < b[column]) {
          return 1;
        }
        return 0;
      });
      setSorted(false);
    }
    setProgramsData(sorted);
  };

  const handleDeleteTemplate = (temp) => {
    setTempToDelete(temp);
  };

  const confirmDeleteTemplate = () => {
    axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
    axios
      .post(window.ajaxLink + "cloud_programs/delete-template", { id: tempToDelete })
      .then((res) => {
        if (res.data.responseData) {
          setRestartTemps(!restartTemps);
          setSuccessPopUp("Protocol has been successfully deleted.");
        }
      })
      .catch((error) => {
        console.error(error);
      });

    setTempToDelete(-1);
  };

  return (
    <div>
      <Menu title={selectedTab === "Recovery Plan" ? "Recovery Plan" : "Protocols"} />
      <div className="programs_dash_hold">
        <div className="programs_dash_top_hold">
          <div className="programs_dash_top_options" >
            <div className="programs_dash_contain_opts">
              <div
              style={{
                marginRight: '36px'
              }}
                className={"programs_dash_option" + (selectedTab === "Recovery Plan" ? " p_d_option_selected" : "")}
                onClick={() => handleSelectedTab("Recovery Plan")}
              >
                Recovery Plan
              </div>
            </div>
            <div className="programs_dash_contain_opts">
              <div
                className={"programs_dash_option" + (selectedTab === "Protocols" ? " p_d_option_selected" : "")}
                onClick={() => handleSelectedTab("Protocols")}
              >
                Protocols
              </div>
            </div>
            <div className={"p_d_selected_slide" + (selectedTab === "Protocols" ? " slide_opt_2" : "")} style={selectedTab === "Recovery Plan" ? {width: "150px"} : {left: "175px"}}></div>
          </div>
          {(programsData.length > 0 || protocolsData?.length > 0) && (
            <Link to={selectedTab === "Protocols" ? "/newtemplate" : "/newprogram"} style={{ textDecoration: "none" }}>
              <div className="programs_new_btn top_hold_btn">
                {selectedTab === "Protocols" ? "New Protocol" : "Create Recovery Plan"}
              </div>
            </Link>
          )}
        </div>
        <div className="table_component_container">
        {/* {contentProgramsLoaded ? ( */}
          <Programs
            programsData={selectedTab === "Protocols" ? protocolsData : programsData}
            searchProgs={searchProgs}
            updateSearchQuery={updateSearchQuery}
            handleSorting={handleSorting}
            contentLoaded={contentProgramsLoaded}
            selectedTab={selectedTab}
            openModal={openModal}
            closeAllModal={closeAllModal}
            handleDeleteTemplate={handleDeleteTemplate}
          />
          
        {/* ) : (
          <div className="full_size_loader">
            <div className="p_load"></div>
          </div>
        )} */}
        </div>
      </div>
      {tempToDelete > -1 && (
        <div className="dlt_wrapper" style={{ position: "fixed" }}>
          <div className="dbl_place_on_page">
            <div className="dlt_surround ">
              <div className="dlt_title">Delete Protocol</div>
              <div className="dlt_description">
                <p>Do you want to delete Protocol?</p>
              </div>
              <div className="dlt_exit_btm">
                <div className="dlt_exit_btn dlt_eb_first" onClick={() => setTempToDelete(-1)}>
                  Cancel
                </div>
                <div className="dlt_exit_btn dlt_eb_scnd" onClick={() => confirmDeleteTemplate()}>
                  Delete
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {successPopUp && (
        <div className="prog_err_hold prog_pop_pat_correct">
          <div className="prog_pop_icon_correct prog_err_icon"></div>
          <div className="prog_err_text prog_pop_text_correct">{successPopUp}</div>
        </div>
      )}
    </div>
  );
};

export default ProgramsDash;
